import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

import type { IFallOption } from '../types';

export default function useFallService(patientUuid: string) {
  const queryClient = useQueryClient();

  const addAction = useMutation({
    mutationFn: async (data: Partial<IFallOption>) => {
      const result = await axios.post<IFallOption>(
        `/api/camel/patient_profile/clinical_info/fall`,
        data,
      );
      invalidateClinicalQuery();
      return result?.data?.uuid;
    },
  });
  const editAction = useMutation({
    mutationFn: async ({ data, uuid }: { data: Partial<IFallOption>; uuid: string }) => {
      await axios.put(`/api/camel/patient_profile/clinical_info/fall/${uuid}`, data);
      invalidateClinicalQuery();
    },
  });
  const deleteAction = useMutation({
    mutationFn: async (uuid: string) => {
      await axios.delete(`/api/camel/patient_profile/clinical_info/fall/${uuid}`);
      invalidateClinicalQuery();
    },
  });

  const invalidateClinicalQuery = async () => {
    await queryClient.invalidateQueries({
      queryKey: ['camel', 'patient_profile', 'clinical_info', patientUuid],
    });
  };

  return {
    addFall: addAction.mutateAsync,
    editFall: editAction.mutateAsync,
    deleteFall: deleteAction.mutateAsync,
  };
}
